// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"a8a3ec85","3983":"5ae2d0a5"}[chunkId] + ".chunk.css";
};